import { NavBar, NavBarItem, Text } from '@audio-network/componentlibrary'
import React, { useEffect, useState } from 'react'

import Link from 'next/link'
import { Search } from '@audio-network/componentlibrary/icons'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './DesktopNavBar.module.css'
import useAiSearchStore from '@/stores/aiSearchStore'
import { usePersistSearchScrollPosition } from '@/pages/track/searchkeyword/index.hooks'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const DesktopNavBar = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const { clearAiSearch } = useAiSearchStore()

	const router = useRouter()
	const [currentPath, setCurrentPath] = useState(router.pathname)
	const { clearSearchScrollPosition } = usePersistSearchScrollPosition()

	useEffect(() => {
		const handleRouteChange = (url: string): void => {
			setCurrentPath(url)
		}

		router.events.on('routeChangeStart', handleRouteChange)

		return () => {
			router.events.off('routeChangeStart', handleRouteChange)
		}
	}, [router])

	const handleClick = (noun: string): void => {
		if (noun === 'Search') {
			/**
			 * Clean up any scroll positioning when navigating to search
			 *
			 * See TrackResults.utils.ts for set up.
			 */
			clearSearchScrollPosition()
			/**
			 * Clean up AI searching
			 */
			clearAiSearch()
		}

		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}
	return (
		<NavBar className={styles.desktopNavBar} id="desktop-nav-bar">
			<Link href="/track/searchkeyword" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={t('music')}
					startIcon={<Search />}
					onClick={() => handleClick('Search')}
					aria-current={
						currentPath === '/track/searchkeyword' ? 'page' : undefined
					}
					id="search-link"
				/>
			</Link>
			<Link href="/playlist-hub" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={t('playlists')}
					href="/playlist-hub"
					onClick={() => handleClick('Playlists')}
					aria-current={currentPath === '/playlist-hub' ? 'page' : undefined}
				/>
			</Link>
			<Link href="/albums" legacyBehavior passHref locale={false}>
				<NavBarItem
					content={t('albums')}
					href="/albums"
					onClick={() => handleClick('Albums')}
					aria-current={currentPath === '/albums' ? 'page' : undefined}
				/>
			</Link>
			{/* Collections is not a Music App page */}
			<NavBarItem
				content={t('collections')}
				href="/collections"
				onClick={() => handleClick('Collections')}
				aria-current={currentPath === '/collections' ? 'page' : undefined}
			/>
			<Link href="/sound-effects" legacyBehavior passHref locale={false}>
				<NavBarItem
					aria-label={t('sound-effects')}
					content={
						<>
							<Text aria-hidden className={styles.sfx}>
								{t('sfx')}
							</Text>
							<Text aria-hidden className={styles.soundEffects}>
								{t('sound-effects')}
							</Text>
							<span className={styles.newBadge}>{t('new')}</span>
						</>
					}
					onClick={() => handleClick('Sound Effects')}
					aria-current={currentPath === '/sound-effects' ? 'page' : undefined}
					id="sound-effects-link"
				/>
			</Link>
		</NavBar>
	)
}

export default DesktopNavBar
